import { useUser } from "@clerk/clerk-react";
import { identifyDataFastUser } from "@/lib/datafast";
import { useEffect, useRef } from "react";

/**
 * Links the anonymous DataFast visitor to the Clerk user after sign-in.
 * Mount inside AppClerkProvider (needs useUser).
 */
export function ClerkDataFastIdentify() {
  const { user, isLoaded, isSignedIn } = useUser();
  const lastIdentifiedId = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !user?.id) return;
    if (lastIdentifiedId.current === user.id) return;
    lastIdentifiedId.current = user.id;

    const email = user.primaryEmailAddress?.emailAddress;
    const name =
      [user.firstName, user.lastName].filter(Boolean).join(" ").trim() ||
      user.fullName ||
      undefined;

    identifyDataFastUser(user.id, {
      name: name || undefined,
      image: user.imageUrl || undefined,
      email: email ?? undefined,
      clerk_user_id: user.id,
    });
  }, [isLoaded, isSignedIn, user]);

  return null;
}
